import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'error',
    encapsulation: ViewEncapsulation.None,
    template: require('./error.template.html')
})
export class ErrorComponent {

    constructor() {
    }

    ngOnInit() {
        console.log('Error component initialized');
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/error/error.component.ts